// extracted by mini-css-extract-plugin
module.exports = {"text":"AuthRegistration_text__2ke4f","timer":"AuthRegistration_timer__2j1M9","link":"AuthRegistration_link__1ZPKQ"};